import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4ad477e1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "aside-container"
};
const _hoisted_2 = {
  class: "aside-logo"
};
const _hoisted_3 = {
  class: "user-info"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-caidan"
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-record"
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-payee"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");
  const _component_router_link = _resolveComponent("router-link");
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_menu = _resolveComponent("el-menu");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_link, {
    to: "/home"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_image, {
      class: _normalizeClass($data.isCollapse ? 'favicon-icon' : 'logo-icon'),
      src: $data.isCollapse ? require('../assets/favicon.png') : require('../assets/logo.png')
    }, null, 8, ["class", "src"])])]),
    _: 1
  }), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: "user-avatar",
    style: _normalizeStyle($data.isCollapse ? {
      width: '60px',
      height: '60px'
    } : {
      width: '104px',
      height: '104px'
    })
  }, [_createVNode(_component_el_image, {
    src: require('../assets/images/default_avatar.webp')
  }, null, 8, ["src"])], 4), _withDirectives(_createElementVNode("div", {
    class: "user-nickname"
  }, _toDisplayString($data.loginAccount), 513), [[_vShow, !$data.isCollapse]])]), _createVNode(_component_el_menu, {
    router: "",
    "default-active": _ctx.$route.path,
    collapse: $data.isCollapse
  }, {
    default: _withCtx(() => [_createVNode(_component_router_link, {
      to: "/home"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_menu_item, {
        index: "/home"
      }, {
        title: _withCtx(() => [_createTextVNode("Front page")]),
        default: _withCtx(() => [_hoisted_4]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_router_link, {
      to: "/transactionRecord"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_menu_item, {
        index: "/transactionRecord"
      }, {
        title: _withCtx(() => [_createTextVNode("Transaction Record")]),
        default: _withCtx(() => [_hoisted_5]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_router_link, {
      to: "/payee"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_menu_item, {
        index: "/payee"
      }, {
        title: _withCtx(() => [_createTextVNode("Payee")]),
        default: _withCtx(() => [_hoisted_6]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["default-active", "collapse"])]);
}